var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGradientColor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 13.3333V6.66667C2.5 4.36548 4.36548 2.5 6.66667 2.5H13.3333C15.6345 2.5 17.5 4.36548 17.5 6.66667V13.3333C17.5 15.6345 15.6345 17.5 13.3333 17.5H6.66667C4.36548 17.5 2.5 15.6345 2.5 13.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 11.2083C6.27293 11.2083 6.29159 11.227 6.29159 11.25C6.29159 11.273 6.27293 11.2916 6.24992 11.2916C6.22691 11.2916 6.20825 11.273 6.20825 11.25C6.20825 11.227 6.22691 11.2083 6.24992 11.2083",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 8.70831C6.27293 8.70831 6.29159 8.72697 6.29159 8.74998C6.29159 8.77299 6.27293 8.79165 6.24992 8.79165C6.22691 8.79165 6.20825 8.77299 6.20825 8.74998C6.20825 8.72697 6.22691 8.70831 6.24992 8.70831",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 6.20831C6.27293 6.20831 6.29159 6.22697 6.29159 6.24998C6.29159 6.27299 6.27293 6.29165 6.24992 6.29165C6.22691 6.29165 6.20825 6.27299 6.20825 6.24998C6.20825 6.22697 6.22691 6.20831 6.24992 6.20831",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.74992 6.20831C8.77293 6.20831 8.79159 6.22697 8.79159 6.24998C8.79159 6.27299 8.77293 6.29165 8.74992 6.29165C8.72691 6.29165 8.70825 6.27299 8.70825 6.24998C8.70825 6.22697 8.72691 6.20831 8.74992 6.20831",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.74992 8.70831C8.77293 8.70831 8.79159 8.72697 8.79159 8.74998C8.79159 8.77299 8.77293 8.79165 8.74992 8.79165C8.72691 8.79165 8.70825 8.77299 8.70825 8.74998C8.70825 8.72697 8.72691 8.70831 8.74992 8.70831",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.74992 11.2083C8.77293 11.2083 8.79159 11.227 8.79159 11.25C8.79159 11.273 8.77293 11.2916 8.74992 11.2916C8.72691 11.2916 8.70825 11.273 8.70825 11.25C8.70825 11.227 8.72691 11.2083 8.74992 11.2083",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.74992 13.7083C8.77293 13.7083 8.79159 13.727 8.79159 13.75C8.79159 13.773 8.77293 13.7916 8.74992 13.7916C8.72691 13.7916 8.70825 13.773 8.70825 13.75C8.70825 13.727 8.72691 13.7083 8.74992 13.7083",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.2499 6.20831C11.2729 6.20831 11.2916 6.22697 11.2916 6.24998C11.2916 6.27299 11.2729 6.29165 11.2499 6.29165C11.2269 6.29165 11.2083 6.27299 11.2083 6.24998C11.2083 6.22697 11.2269 6.20831 11.2499 6.20831",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.2499 8.70831C11.2729 8.70831 11.2916 8.72697 11.2916 8.74998C11.2916 8.77299 11.2729 8.79165 11.2499 8.79165C11.2269 8.79165 11.2083 8.77299 11.2083 8.74998C11.2083 8.72697 11.2269 8.70831 11.2499 8.70831",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.2499 11.2083C11.2729 11.2083 11.2916 11.227 11.2916 11.25C11.2916 11.273 11.2729 11.2916 11.2499 11.2916C11.2269 11.2916 11.2083 11.273 11.2083 11.25C11.2083 11.227 11.2269 11.2083 11.2499 11.2083",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.2499 13.7083C11.2729 13.7083 11.2916 13.727 11.2916 13.75C11.2916 13.773 11.2729 13.7916 11.2499 13.7916C11.2269 13.7916 11.2083 13.773 11.2083 13.75C11.2083 13.727 11.2269 13.7083 11.2499 13.7083",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 13.7916C6.22691 13.7916 6.20825 13.773 6.20825 13.75C6.20825 13.727 6.22691 13.7083 6.24992 13.7083C6.27293 13.7083 6.29159 13.727 6.29159 13.75C6.29159 13.773 6.27293 13.7916 6.24992 13.7916",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGradientColor);
export default ForwardRef;